/** @var string Создание рейса с доп полями*/
export const EXTENDED_DELIVERY_INFO = 'extended_delivery_info';